// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file bffuser/v1/announcement_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import { AnnouncementService } from "./announcement_service_pb";

/**
 * ListAnnouncements は公開済み (配信側 index.json 掲載) の告知を
 * published_at 降順で全件返す。ページングは持たない (年数十件規模)。
 * index.json が未配信の環境では空を返す。
 *
 * @generated from rpc bffuser.v1.AnnouncementService.ListAnnouncements
 */
export const listAnnouncements = AnnouncementService.method.listAnnouncements;

/**
 * GetAnnouncement は 1 件の告知本文を返す。index.json に載っていない
 * announcement_id は NotFound。
 *
 * @generated from rpc bffuser.v1.AnnouncementService.GetAnnouncement
 */
export const getAnnouncement = AnnouncementService.method.getAnnouncement;
